import { RESET_FORM } from '../actionTypes';
import { managePasswordActions } from '../reducer';

export default () => managePasswordActions[RESET_FORM]();
